import React from 'react';
import { ConfirmProvider } from './Dialog';
import { ToastProvider } from './Toast';

/** Toasts and confirmations for the whole app (mounted once, in index.js). */
export default function UIProvider({ children }) {
  return (
    <ToastProvider>
      <ConfirmProvider>{children}</ConfirmProvider>
    </ToastProvider>
  );
}
